export default __webpack_public_path__ + "static/media/COmpressionAir-img1.e5332b60.png";